<ng-container *ngIf="sessionId && course">
  <div class="dialog-container">
    <div class="header">
      <div class="header-title text-truncate programs-h5"> {{ course.title }}</div>
      <button mat-stroked-button color="primary" (click)="openAssessmentDashboard()" *ngIf="assessmentResult">
        <mat-icon>remove_red_eye</mat-icon>
        <span>OPEN REPORT</span>
      </button>
    </div>
    
    <div class="logs-container">
      <xapi-log programsMode="true" [sessionId]="sessionId"></xapi-log>
    </div>

    <div class="buttons-parent">
      <button mat-button color="primary" (click)="closeDialog()">
        <span>CLOSE</span>
      </button>
      <button mat-raised-button color="primary" (click)="downloadLogs()">
        <mat-icon>download</mat-icon>
        <span>DOWNLOAD LOGS</span>
      </button>
    </div>
  </div>
</ng-container>
